import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import SessionsTable from "../container/Program/SessionsTable";

const Sessions = () => {
  const showFlag = false;

  return (
    <React.Fragment>
      <SEO title="Sessions | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Sessions"
        content="The Conference"
        contentTwo="Sessions"
        linkage="/"
      />

      <EmptyTwo>
        {showFlag ? (
          <>
            <div className="entry-content title-center">
              <h2>ICSI&apos;2026 Detailed Session Schedule</h2>
            </div>
            <div className="entry-content title-center">
              <SessionsTable />
            </div>
          </>
        ) : (
          <div className="entry-content title-center">
            <h2>
              Due to the change in the conference host city, we are working
              diligently to rearrange the parallel sessions. Please stay tuned!
            </h2>
          </div>
        )}
      </EmptyTwo>

      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Sessions;
